var $class="se2--banner-full-image-carousel--slide",$name="BannerFullImageCarousel/slide",$path="app/components/BannerFullImageCarousel/partials/slide/utilities/getPauseAfterPlayVideo.js",$this={$class,$name,$path,};const getPauseAfterPlayVideo = (element) => element?.play().then(() => element.pause());

export default getPauseAfterPlayVideo;
